import React from 'react'
import Head from 'next/head'
import PropTypes from 'prop-types'
import ArticleImages from '@/component/Primitive/ArticleImages'
import changeFileExtension from '@/lib/filename-extension-modifier'

const ArticleLayoutImagesWidget = ({ article }) => {
  const srcSetFormatter = (srcSet) => {
    return srcSet.map((image) => `${image.src} ${image.width}w`).join(', ')
  }

  const ratioMap = {
    Interview: 455 / 322,
    Whitepaper: 455 / 322,
    Video: 375 / 668
  }

  const mobileSizes = [138, 206, 290, 412, 580, 900]
  const mobileSrcSet = mobileSizes.map((size) => {
    return {
      width: size,
      src: changeFileExtension(
        article.images?.[`thumbnail_landscape_${size}`]?.[0]?.url,
        'webp'
      )
    }
  })

  const desktopSizes = [1336, 1800]
  const desktopSrcSet = desktopSizes.map((size) => {
    return {
      width: size,
      src: changeFileExtension(
        article.images?.[`hero_landscape_${size}`]?.[0]?.url,
        'webp'
      )
    }
  })

  const formattedArticle = {
    ...article,
    src: changeFileExtension(
      article.images?.thumbnail_landscape_138?.[0]?.url,
      'webp'
    ),
    srcSet: [...mobileSrcSet, ...desktopSrcSet],
    sizes: [
      '(min-width: 1060px) 668px',
      '(min-width: 960px) calc(100vw - 364px)',
      'calc((100vw - 80px) * 0.5)'
    ]
  }

  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          href={formattedArticle.src}
          imagesrcset={srcSetFormatter(formattedArticle.srcSet)}
          imagesizes={formattedArticle.sizes}
        />
      </Head>
      <ArticleImages
        alt="Article Image"
        images={formattedArticle.images}
        contentType={formattedArticle.contentType}
        imageRatio={ratioMap[formattedArticle.contentType] || 126 / 167}
        videoProvider={formattedArticle.videoProvider}
        videoId={formattedArticle.videoId}
        caption={article.images?.thumbnail_landscape_138?.[0]?.caption}
        src={formattedArticle.src}
        srcSet={formattedArticle.srcSet}
        sizes={formattedArticle.sizes}
      />
    </>
  )
}

ArticleLayoutImagesWidget.propTypes = {
  article: PropTypes.shape({
    images: PropTypes.object,
    contentType: PropTypes.string,
    videoProvider: PropTypes.string,
    videoId: PropTypes.string
  })
}

export default ArticleLayoutImagesWidget
